export default "__VITE_ASSET__DTTGbRLj__"